export const STATUS_META = {
  pending:      { label: "PENDING",      bg: "#FFF7D6", fg: "#8A6A00", bd: "#FFCC00" },
  approved:     { label: "APPROVED",     bg: "#E4F5EA", fg: "#1E7C3B", bd: "#34C759" },
  in_progress:  { label: "IN PROGRESS",  bg: "#E6ECFF", fg: "#0B4DCC", bd: "#0B4DCC" },
  completed:    { label: "COMPLETED",    bg: "#0B1F3A", fg: "#FFFFFF", bd: "#0B1F3A" },
  rejected:     { label: "REJECTED",     bg: "#FDE7E6", fg: "#B72318", bd: "#FF3B30" },
};

export default function StatusBadge({ status, testid }) {
  const m = STATUS_META[status] || STATUS_META.pending;
  return (
    <span
      className="fx-badge"
      style={{ background: m.bg, color: m.fg, borderColor: m.bd }}
      data-testid={testid || `status-badge-${status}`}
    >
      {m.label}
    </span>
  );
}
